/**
 * Logo Telegram (glyph resmi Simple Icons, lisensi CC0) sebagai komponen ikon.
 *
 * Dipakai tombol "Materi iklan" di halaman detail produk — tombol itu membawa
 * pengunjung KELUAR ke channel Telegram merek, dan ikon generik (`Send` lucide,
 * yang dipakai chip Telegram di panel admin) tak memberi tahu ke mana. Di
 * storefront tombolnya bersaing dengan badge merek & segmen, jadi logonya harus
 * dikenali tanpa perlu membaca labelnya.
 *
 * Monokrom lewat `currentColor` (bukan biru hardcode) supaya mewarisi warna
 * teks tombolnya persis seperti ikon lucide lain & `WhatsappIcon`:
 *   <TelegramIcon className="h-3.5 w-3.5" />
 */
export function TelegramIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );
}
